import { Box, Grid, Collapse, Card } from "@mui/material";

import ActiveFilters from "../../../../../Components/filters/ActiveFilters";
import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  drivers,
}) => {
  const getDriverName = (driverId) => {
    if (!driverId) return "";
    const driver = drivers.find((d) => d.driver_id === driverId);
    return driver ? driver.full_name : driverId;
  };

  const activeFilterDefinitions = [
    {
      type: "standard",
      id: "driver_id",
      label: "Driver",
      value: getDriverName(submittedData.driver_id),
    },
  ];

  return (
    <>
      <Grid item xs={12} sx={{ mb: filterOpen ? 2 : 0 }}>
        <Collapse in={filterOpen}>
          <Card>
            <Box p={4}>
              <FilterItems
                filterData={filterData}
                handleChangeFilter={handleChangeFilter}
                handleFilter={handleFilter}
                handleClearFilters={handleClearFilters}
                drivers={drivers}
              />
            </Box>
          </Card>
        </Collapse>
      </Grid>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </>
  );
};

export default Filter;
